<div>
  <app-message [service]="messageService"></app-message>
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <div class="form-group mb-2">
      <label for="name" i18n="@@NameOfStationLabel">Name der Ladestation*</label>
      <input type="text" id="name" formControlName="name" class="form-control" placeholder="Name der Ladestation*"
        i18n-placeholder="@@ChargingStationName" />

      <div class="error">
        <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'required')"
          i18n="@@NameOfStationRequiredError">Name/Bezeichner wird benötigt</em>
        <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'pattern')"
          i18n="@@NameOfStationIncorrectInputError">Name/Bezeichner ist nicht gültig</em>
      </div>
    </div>

    <div class="form-row row mb-2">
      <div class="col-8">
        <label for="street" i18n="@StreetLabel">Straße*</label>
        <input type="text" id="street" formControlName="street" class="form-control" placeholder="Straße"
          i18n-placeholder="@@StreetPlaceholder" />

        <div class="error">
          <em *ngIf="formService.validateControl('street') && formService.hasError('street', 'required')"
            i18n="@@StreetRequiredError">Straße wird benötigt</em>
        </div>
      </div>
      <div class="col-4">
        <label for="houseNumber" i18n="@HouseNumberLabel">Nr*</label>
        <input type="text" id="houseNumber" formControlName="houseNumber" class="form-control" placeholder="Nr."
          i18n-placeholder="@@HouseNumberPlaceholder" />

        <div class="error">
          <em *ngIf="formService.validateControl('houseNumber') && formService.hasError('houseNumber', 'required')"
            i18n="@@StreetRequiredError">Hausnummer wird benötigt</em>
        </div>
      </div>
    </div>

    <div class="form-row row mb-2">
      <div class="col-4">
        <label for="postalCode" i18n="@postalCodeLabel">PLZ*</label>
        <input type="text" id="postalCode" maxlength="6" #postalCode formControlName="postalCode"
          (input)="postalCodeInput($event)" class="form-control" placeholder="PLZ"
          i18n-placeholder="@@postalCodePlaceholder" />

        <div class="error">
          <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'required')"
            i18n="@@StreetRequiredError">PLZ wird benötigt</em>

          <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'pattern')"
            i18n="@@IncorrectInputError">Falsche Eingabe</em>

          <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'minlength')"
            i18n="@@MissingNumbersPLZError">PLZ zu kurz</em>
          <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'maxlength')"
            i18n="@@ExceededMaxLengthPLZError">PLZ zu lang</em>
        </div>
      </div>
      <div class="col-8">
        <label for="city" i18n="@cityLabel">Ort*</label>
        <input type="text" id="city" formControlName="city" class="form-control" placeholder="Ort"
          i18n-placeholder="@@cityPlaceholder" />

        <div class="error">
          <em *ngIf="formService.validateControl('city') && formService.hasError('city', 'required')"
            i18n="@@StreetRequiredError">Ort wird benötigt</em>
        </div>
      </div>
    </div>
    <div class="form-row row mb-2">
      <div class="col-4">
        <label for="country" i18n="@@CountryLabel">Land</label>
        <input type="text" id="country" formControlName="country" class="form-control" placeholder="Land"
          i18n-placeholder="@@CountryPlaceholder" />
      </div>
    </div>

    <div class="form-row row mb-2">
      <div class="col">
        <label for="manufacturer" i18n="@@ManufacturerLabel">Hersteller*</label>
        <select class="form-select" id="manufacturerId" formControlName="manufacturerId"
          aria-label="ManufacturersSelect" placeholder="Hersteller*" i18n-placeholder="@@ManufacturerPlaceholder"
          (change)="getModels($event.target.value)">
          <option value="" disabled hidden>Hersteller*</option>
          <option *ngFor="let manufacturer of this.manufacturers" value="{{manufacturer.id}}">{{manufacturer.name}}
          </option>
        </select>

        <div class="error">
          <em
            *ngIf="formService.validateControl('manufacturerId') && formService.hasError('manufacturerId', 'required')"
            i18n="@@ManufacturerRequiredError">Hersteller wird benötigt</em>
          <em *ngIf="formService.validateControl('manufacturerId') && formService.hasError('manufacturerId', 'pattern')"
            i18n="@@ManufacturerIncorrectInputError">Hersteller ist nicht gültig</em>
        </div>
      </div>

      <div class="col">
        <label for="model" i18n="@@ModelLabel">Modell*</label>
        <select class="form-select" id="modelId" formControlName="modelId" aria-label="ModelSelect"
          placeholder="Modell*" i18n-placeholder="@@ModelPlaceholder" #selectedModel
          (change)="modelIdChange(selectedModel.value)">
          <option value="" disabled selected hidden>Modell*</option>
          <option *ngFor="let models of this.modelsOfManufacturer" value="{{models.id}}">{{models.name}}</option>
        </select>

        <div class="error">
          <em *ngIf="formService.validateControl('modelId') && formService.hasError('modelId', 'required')"
            i18n="@@ModelRequiredError">Modell wird benötigt</em>
          <em *ngIf="formService.validateControl('modelId') && formService.hasError('modelId', 'pattern')"
            i18n="@@ModelIncorrectInputError">Modell ist nicht gültig</em>
        </div>
      </div>
    </div>
    <div class="form-row row mb-2">
      <div class="col">
        <label for="numOfChargingStations">Anzahl der anzulegenden Ladestationen</label>
        <input type="text" class="form-control" id="numOfChargingStations" name="numOfChargingStations"
          formControlName="numOfChargingStations" placeholder="" aria-label="Number of Chargingstation to generate"
          aria-describedby="btnGenerateChargingStations">
      </div>
      <div class="error">
        <em
          *ngIf="formService.validateControl('numOfChargingStations') && formService.hasError('numOfChargingStations', 'required')"
          i18n="@@ModelRequiredError">Anzahl wird benötigt</em>
      </div>
    </div>
    <strong>Passwort generieren</strong>
    <hr class="m-0 p-0" />
    <div class="form-row row mt-2 mb-2">
      <div class="col-sm-3">
        <label for="length">Länge:</label>
        <input type="number" name="length" class="form-control" (change)="pwlength($event)" min="8" max="40" value="12">
      </div>
      <div class="col align-content-end" style="display:inline;vertical-align: middle;padding-bottom:0.4rem;">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="numbers" value="1" (change)="hasNum($event)"
            checked>
          <label class="form-check-label" for="numbers">mit Zahlen</label>
        </div>
      </div>
      <div class="col align-content-end" style="display:inline;vertical-align: middle;padding-bottom:0.4rem;">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="symbols" value="1"
            (change)="hasSym($event)">
          <label class="form-check-label" for="symbols">mit Sonderzeichen</label>
        </div>
      </div>
    </div>
    <div class="input-group mb-3">
      <button class="btn btn-outline-secondary" type="button" id="btnGeneratePwd"
        (click)="generatePassword()">Generieren</button>
      <input type="text" class="form-control" id="key" name="key" formControlName="key" placeholder=""
        aria-label="Generated password" aria-describedby="btnGeneratePwd">
    </div>
  </form>
</div>